import DashboardIcon from '@mui/icons-material/Dashboard'

import { haveRole } from '@/lib/admin/getIsUserBackOffice'
import { EntityList } from '@/types/Entity'
import { CONSTANTS } from '@/types/enum/constants'

/**
 * Routes backoffice pour le role consult Care (ROLE_CARE_ADMIN_CONSULT cote API,
 * route dynamique ROLE_DYNAMIC_ROUTE_CARE_ADMIN_CONSULT cote front).
 * Acces en lecture seule au dashboard de statistiques Care admin.
 */
const getBackOfficeCareAdminConsult = [
  {
    route: 'Dashboard',
    text: 'Tableau de bord',
    icon: DashboardIcon,
    href: '/backoffice/care/dashboard-consult',
    home: true,
    menuHeader: true,
    position: 10,
    // Un super admin recoit deja un « Tableau de bord » Care via getBackOfficeCareAdmin
    // (dashboard admin commun) : masquer la variante consult pour lui, sinon le menu
    // affiche DEUX « Tableau de bord » Care.
    fnDisplay: ({ dataMyProfile }) =>
      !haveRole(dataMyProfile?.loggedUserRoles, [CONSTANTS.ROLE_SUPER_ADMIN]),
  },
  {
    route: 'MyProfile',
    text: 'Mon profil',
    href: '/backoffice/common/my-profile',
    menuHeader: false,
  },
].map(route => ({
  ...route,
  entity: [EntityList.PHARMEDICARE],
  roles: [CONSTANTS.ROLE_DYNAMIC_ROUTE_CARE_ADMIN_CONSULT],
}))

export default getBackOfficeCareAdminConsult
